export default __webpack_public_path__ + "static/media/notice.b60725a6.jpeg";